import { render, staticRenderFns } from "./NToggleBtn.vue?vue&type=template&id=348e0716"
import script from "./NToggleBtn.vue?vue&type=script&lang=js"
export * from "./NToggleBtn.vue?vue&type=script&lang=js"
import style0 from "./NToggleBtn.vue?vue&type=style&index=0&id=348e0716&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports